import React from 'react';
import { makeStyles } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
    Style: {
        margin: 'auto',
        '& svg': {
            width: '1.4rem',
            height: '1.4rem',
            [theme.breakpoints.down('600')]: {
                width: '2rem',
                height: '2rem'
            }
        }
    },
}));

export const True = (props) => {
    const classes = useStyles();

    return (
        <span className={`options--check ${classes.Style}`}>
            <svg width="20" height="20" viewBox="0 0 45.371 33">
                <path id="Path_314" data-name="Path 314" d="M49.31,7.869a3.228,3.228,0,0,0-4.565-.019l-.019.019L20.674,31.953l-10.1-10.137a3.3,3.3,0,0,0-4.584,4.746l12.4,12.4a3.228,3.228,0,0,0,4.565.019l.019-.019L49.31,12.615a3.229,3.229,0,0,0,.184-4.562A2.475,2.475,0,0,0,49.31,7.869Z" transform="translate(-4.978 -6.914)" fill="#b5c700"/>
            </svg>
        </span>
    )
}

export const False = (props) => {
    const classes = useStyles();

    return (
        <span className={`options--check ${classes.Style}`}>
            <svg className={classes.svgStyle} version="1.1" x="0" y="0" viewBox="0 0 512.001 512.001">
                <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717    L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285L284.286,256.002z" fill="#e90a0a" data-original="#000000" />
            </svg>
        </span>
    )
}